import 'swiper/swiper-bundle.css';
import { Swiper, Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

const sliders = document.querySelectorAll('.slider');

function initSlider(item) {
  const swiperItem = item.querySelector('.swiper-container')

  const buttons = item.querySelectorAll('.gallery__item');
  const swiperCaption = item.querySelectorAll('.swiper-captions > div');

  const swiper = new Swiper(swiperItem, {
    slidesPerView: 1,
    watchOverflow: true,
    spaceBetween: swiperItem.classList.contains('swiper-container--product-images') ? 0 : 32,
    breakpoints: swiperItem.classList.contains('swiper-container--wide') ? null :{
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: swiperItem.classList.contains('swiper-container--product-images') ? 2 : 3,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: item.querySelector('.swiper-button-next'),
      prevEl: item.querySelector('.swiper-button-prev'),
    },

    // Pagination
    //add custom pagination html
    pagination: {
      el: item.querySelector('.swiper-pagination'),
      clickable: true,
      renderBullet: function (index, className) {
        if (buttons[index].title !== undefined && buttons[index].title !== '') {
          return '<span class="' + className + ' mb-4" title="'+ buttons[index].title +'"><strong class="mt-2 block">'+ buttons[index].title + '</strong></span>';
        } else {
          return '<span class="' + className + '"></span>';
        }
      }

    },
  });

  if (swiperCaption.length === 0) return;

  //find element from swiperCaption array that has data-key equal to current slide index
  swiperCaption.forEach((caption, index) => {
    if (caption.dataset.key === '0') {
      caption.classList.add('active');
    }
  });

  swiper.on('slideChange', function () {
    swiperCaption.forEach((caption, index) => {
      if (caption.dataset.key === swiper.realIndex.toString()) {
        caption.classList.add('active');
      } else {
        caption.classList.remove('active');
      }
    });

  });
}

if ('IntersectionObserver' in window) {
  let lazySliderObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        initSlider(entry.target)
        lazySliderObserver.unobserve(entry.target);
      }
    });
  });
  sliders.forEach(function(slider) {
    lazySliderObserver.observe(slider);
  });
} else {
  sliders.forEach((slider) => {
    initSlider(slider);
  });
}
